import React from "react"
import PropTypes from "prop-types"

import "./Rating.scss"
import Stars from "./Stars";

function Rating({activity, textMode, hideIfNoRating, centered}) {
  if(hideIfNoRating && !activity.ratingAverage) {
    return null
  }
  let ratingAverage = 0
  let ratingCount = 0
  if(activity.ratingAverage) {
    ratingAverage = activity.ratingAverage
    ratingCount = activity.ratingCount || 1
  }
  if(ratingCount < 3 && ratingAverage < 3) {
    ratingCount = 0
    ratingAverage = 0
  }

  let text = null
  let direction = "row"
  
  if(textMode === "average") {
    if(ratingCount === 0 || ratingAverage === 0) {
      text = <span className="text"></span>
    }
    else {
      text = <span className="text">{`(${ratingAverage.toFixed(1)})`}</span>
    }
    direction = "row"
  }
  else {
    if(ratingCount === 0 || ratingAverage === 0) {
      text = <span className="text">noch keine Bewertungen</span>
    }
    else {
      text = <span className="text">{`${ratingAverage.toFixed(1) }/5 (${ratingCount})`}</span> 
    }
    direction = "column"
  }

  
  // render
  return (
    <div className={`c-rating ${direction} ${centered ? "centered":""}`}>
      <Stars rating={ratingAverage || 0} size="10" />
      {text}
    </div>
  )
}

Rating.propTypes = {
  textMode:PropTypes.oneOf(["none", "average", "averageAndCount"])
}

Rating.defaultProps = {
  textMode:"average"
}


export default Rating